import React, { useState, useEffect } from 'react';
import {
    MapPin, Phone, Mail, Wifi, Coffee, Car,
    Flame, Utensils, Mountain,
    Menu, X, ChevronLeft, ChevronRight, Star, CheckCircle2, MessageCircle
} from 'lucide-react';
import logoImage from './assets/Apple-Town-Manali-New.jpeg';
import heroImage1 from './assets/apple-town/1.jpg';
import heroImage2 from './assets/apple-town/2.jpg';
import heroImage3 from './assets/apple-town/3.jpg';
import heroImage4 from './assets/apple-town/4.jpg';
import heroImage5 from './assets/apple-town/5.jpg';
import roomImage1 from './assets/apple-town/rooms/1.jpg';
import roomImage2 from './assets/apple-town/rooms/2.jpg';
import roomImage3 from './assets/apple-town/rooms/3.jpg';
import roomImage4 from './assets/apple-town/rooms/4.jpg';
import roomImage5 from './assets/apple-town/rooms/5.jpg';
import roomImage6 from './assets/apple-town/rooms/6.jpg';
import roomImage7 from './assets/apple-town/rooms/7.jpg';
import roomImage8 from './assets/apple-town/rooms/8.jpg';

// --- Custom Icons ---
const WhatsAppIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
);

const FacebookIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073c0 6.019 4.388 11.008 10.125 11.927v-8.438H7.078V12.07h3.047V9.413c0-3.017 1.792-4.684 4.533-4.684 1.313 0 2.686.236 2.686.236v2.963H15.83c-1.49 0-1.955.93-1.955 1.887v2.255h3.328l-.532 3.492h-2.796V24C19.612 23.081 24 18.092 24 12.073Z" />
    </svg>
);

const InstagramIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.75 2h8.5A5.756 5.756 0 0 1 22 7.75v8.5A5.756 5.756 0 0 1 16.25 22h-8.5A5.756 5.756 0 0 1 2 16.25v-8.5A5.756 5.756 0 0 1 7.75 2Zm0 1.75A4.005 4.005 0 0 0 3.75 7.75v8.5a4.005 4.005 0 0 0 4 4h8.5a4.005 4.005 0 0 0 4-4v-8.5a4.005 4.005 0 0 0-4-4h-8.5ZM17.5 6.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z" />
    </svg>
);

// --- Configuration & Data ---
const HOTEL_NAME = "Apple Town Manali";
const LOGO_IMG = logoImage;

// Placeholder room images for your actual photography
const ROOM_IMAGES = [
    roomImage1,
    roomImage2,
    roomImage3,
    roomImage4,
    roomImage5,
    roomImage6,
    roomImage7,
    roomImage8
];

const FACILITIES = [
    { icon: <Wifi className="w-8 h-8" />, name: "High-Speed Wi-Fi", desc: "Stay connected even high up in the mountains." },
    { icon: <Flame className="w-8 h-8" />, name: "Central Heating", desc: "Cozy rooms to keep the Manali winter chill away." },
    { icon: <Utensils className="w-8 h-8" />, name: "In-house Restaurant", desc: "Authentic Himachali and multi-cuisine dishes." },
    { icon: <Car className="w-8 h-8" />, name: "Free Parking", desc: "Secure on-site parking for your vehicles." },
    { icon: <Mountain className="w-8 h-8" />, name: "Trekking Guides", desc: "Arrangements for Rohtang & Solang Valley tours." },
    { icon: <Coffee className="w-8 h-8" />, name: "24/7 Cafe", desc: "Warm beverages to enjoy the mountain breeze." }
];

const HERO_IMAGES = [
    heroImage1,
    heroImage2,
    heroImage3,
    heroImage4,
    heroImage5,
];

// --- Components ---

const Navbar = ({ isScrolled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isNavSolid = isScrolled || isOpen;

    const navLinks = [
        { name: "Home", href: "#home" },
        { name: "Rooms", href: "#rooms" },
        { name: "Facilities", href: "#facilities" },
        { name: "Contact", href: "#contact" },
    ];

    return (
        <nav className={`fixed top-0 left-0 right-0 w-full z-[100] transition-all duration-300 ${isNavSolid ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-5'}`}>
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center">
                    <div className="flex-shrink-0 flex items-center">
                        <a href="#home" className="flex items-center gap-3">
                            <img
                                src={LOGO_IMG}
                                alt="Apple Town Manali Logo"
                                className={`rounded-full object-cover transition-all duration-300 shadow-md border-2 border-white/20 ${isNavSolid ? 'h-14 w-14' : 'h-[4.5rem] w-[4.5rem]'}`}
                            />
                        </a>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex space-x-8 items-center">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                className={`text-sm font-medium uppercase tracking-wide hover:text-emerald-500 transition-colors ${isNavSolid ? 'text-gray-600' : 'text-gray-200'}`}
                            >
                                {link.name}
                            </a>
                        ))}
                        <div className="flex items-center gap-3">
                            <a
                                href="https://wa.me/919278065558?text=Hello!%20I%20would%20like%20to%20inquire%20about%20booking%20a%20room%20at%20Apple%20Town%20Manali."
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Chat on WhatsApp"
                                className={`w-11 h-11 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all ${isNavSolid ? 'bg-[#25D366] text-white hover:bg-[#20bd5a]' : 'bg-white text-[#25D366] hover:bg-gray-100'}`}
                            >
                                <WhatsAppIcon className="w-5 h-5" />
                            </a>
                            <a
                                href="tel:+919278065558"
                                aria-label="Call now"
                                className={`w-11 h-11 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all ${isNavSolid ? 'bg-emerald-600 text-white hover:bg-emerald-700' : 'bg-white text-emerald-700 hover:bg-gray-100'}`}
                            >
                                <Phone className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center gap-2">
                        <a
                            href="https://wa.me/919278065558?text=Hello!%20I%20would%20like%20to%20inquire%20about%20booking%20a%20room%20at%20Apple%20Town%20Manali."
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Chat on WhatsApp"
                            className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${isNavSolid ? 'bg-[#25D366] text-white' : 'bg-white/90 text-[#25D366]'}`}
                        >
                            <WhatsAppIcon className="w-5 h-5" />
                        </a>
                        <a
                            href="tel:+919278065558"
                            aria-label="Call now"
                            className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${isNavSolid ? 'bg-emerald-600 text-white' : 'bg-white/90 text-emerald-700'}`}
                        >
                            <Phone className="w-5 h-5" />
                        </a>
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            aria-label={isOpen ? 'Close menu' : 'Open menu'}
                            className={`w-10 h-10 rounded-xl border flex items-center justify-center transition-colors ${isNavSolid ? 'text-gray-900 border-gray-200 bg-white' : 'text-white border-white/50 bg-black/15'}`}
                        >
                            {isOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden absolute top-full left-0 right-0 px-4 max-[375px]:px-5 pt-2 pb-3">
                    <div className="rounded-2xl border border-gray-200 bg-white/95 backdrop-blur-md shadow-2xl p-3 space-y-2">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                onClick={() => setIsOpen(false)}
                                className="block w-full rounded-xl px-4 py-3 text-gray-800 font-semibold bg-gray-50 hover:bg-emerald-50 hover:text-emerald-700 transition-colors"
                            >
                                {link.name}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            onClick={() => setIsOpen(false)}
                            className="block w-full rounded-xl px-4 py-3 text-center font-bold text-white bg-emerald-600 hover:bg-emerald-700 transition-colors"
                        >
                            Book Now
                        </a>
                    </div>
                </div>
            )}
        </nav>
    );
};

const Hero = () => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % HERO_IMAGES.length);
        }, 2000); // Change image every 5 seconds

        return () => clearInterval(timer);
    }, []);

    return (
        <div id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
            {/* Background Image Carousel & Overlay */}
            {HERO_IMAGES.map((img, index) => (
                <img
                    key={`hero-${index}`}
                    src={img}
                    alt={`Apple Town hero ${index + 1}`}
                    className={`absolute inset-0 z-0 w-full h-full object-cover transition-all duration-1000 ease-in-out ${index === currentImage ? 'opacity-100 scale-105' : 'opacity-0 scale-100'
                        }`}
                    loading="eager"
                    decoding="async"
                />
            ))}
            <div className="absolute inset-0 z-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

            {/* Content */}
            <div className="relative z-10 text-center px-4 max-[375px]:px-5 max-w-4xl mx-auto mt-10 sm:mt-14 md:mt-20 pb-12 max-[375px]:pb-20 sm:pb-0">
                <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-white font-bold mb-6 drop-shadow-lg leading-tight">
                    Find Your Peace at <br /> <span className="text-emerald-400">Apple Town Manali</span>
                </h1>
                <p className="text-base sm:text-lg md:text-2xl text-gray-200 mb-8 md:mb-10 max-w-2xl mx-auto font-light leading-relaxed">
                    Escape to the breathtaking valleys of Himachal. Wake up to majestic snow peaks, the soothing sounds of the Beas River, and our lush apple orchards.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
                    <a href="#contact" className="px-8 py-4 bg-emerald-600 text-white rounded-lg font-bold text-lg hover:bg-emerald-500 transition-colors w-full sm:w-auto text-center shadow-[0_0_20px_rgba(16,185,129,0.4)] flex items-center justify-center gap-2">
                        <MessageCircle className="w-5 h-5" /> Reserve Now
                    </a>
                    <a href="#rooms" className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-bold text-lg hover:bg-white hover:text-gray-900 transition-colors w-full sm:w-auto text-center flex items-center justify-center">
                        Explore Rooms <ChevronRight className="w-5 h-5 ml-2" />
                    </a>
                </div>
            </div>

            {/* Carousel Indicators */}
            <div className="absolute bottom-5 sm:bottom-8 md:bottom-10 left-0 right-0 z-20 flex justify-center space-x-3">
                {HERO_IMAGES.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentImage(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-emerald-500 w-8' : 'bg-white/50 hover:bg-white'
                            }`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

const Rooms = () => {
    const [currentRoomImage, setCurrentRoomImage] = useState(0);
    const [isRoomHovered, setIsRoomHovered] = useState(false);

    useEffect(() => {
        if (isRoomHovered) {
            return undefined;
        }

        const timer = setInterval(() => {
            setCurrentRoomImage((prev) => (prev + 1) % ROOM_IMAGES.length);
        }, 2000);

        return () => clearInterval(timer);
    }, [isRoomHovered]);

    const goToPrevRoomImage = () => {
        setCurrentRoomImage((prev) => (prev - 1 + ROOM_IMAGES.length) % ROOM_IMAGES.length);
    };

    const goToNextRoomImage = () => {
        setCurrentRoomImage((prev) => (prev + 1) % ROOM_IMAGES.length);
    };

    return (
        <section id="rooms" className="py-6 md:py-10 lg:py-14 bg-gray-50 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8">

            <div className="flex flex-col lg:flex-row gap-8 md:gap-10 lg:gap-14 items-center">

                    {/* Manali Contextual Description */}
                    <div className="lg:w-5/12 text-center lg:text-left">
                        <h2 className="text-sm font-bold text-emerald-600 tracking-widest uppercase mb-2">Our Rooms</h2>
                        <h3 className="text-2xl md:text-5xl font-serif text-gray-900 font-bold mb-3 md:mb-6 leading-tight">
                            A Cozy Sanctuary in the Hills
                        </h3>

                        <p className="text-gray-600 mb-3 md:mb-6 text-base md:text-lg leading-relaxed">
                            Nestled perfectly in the serene landscapes of Manali, our rooms are crafted to offer you a warm, tranquil retreat. After a long day of exploring the bustling Mall Road or traversing the snowy slopes of Rohtang Pass, return to a space that feels like home.
                        </p>

                        <p className="text-gray-600 mb-5 md:mb-8 text-base md:text-lg leading-relaxed">
                            Featuring traditional Himachali wood aesthetics combined with modern comforts, panoramic windows opening to the pine forests, and premium bedding to keep you snug in the crisp mountain weather.
                        </p>

                        <ul className="space-y-2 md:space-y-3 mb-5 md:mb-8 text-left inline-block lg:block">
                            <li className="flex items-center text-gray-700 font-medium">
                                <CheckCircle2 className="w-5 h-5 mr-3 text-emerald-500" /> Panoramic Valley Views
                            </li>
                            <li className="flex items-center text-gray-700 font-medium">
                                <CheckCircle2 className="w-5 h-5 mr-3 text-emerald-500" /> Premium Wooden Interiors
                            </li>
                            <li className="flex items-center text-gray-700 font-medium">
                                <CheckCircle2 className="w-5 h-5 mr-3 text-emerald-500" /> 24/7 Room Service & Heating
                            </li>
                        </ul>

                        <div className="text-center lg:text-left">
                            <a href="#contact" className="inline-flex items-center px-8 py-4 bg-gray-900 text-white rounded-lg font-bold hover:bg-emerald-600 transition-colors shadow-xl hover:shadow-2xl">
                                Check Availability <ChevronRight className="w-5 h-5 ml-2" />
                            </a>
                        </div>
                    </div>

                    {/* Room slider: auto-plays and pauses while hovered */}
                    <div className="lg:w-7/12 w-full">
                        <div
                            className="relative rounded-2xl overflow-hidden shadow-2xl h-[260px] sm:h-[420px] lg:h-[520px]"
                            onMouseEnter={() => setIsRoomHovered(true)}
                            onMouseLeave={() => setIsRoomHovered(false)}
                        >
                            <img
                                src={ROOM_IMAGES[currentRoomImage]}
                                alt={`Room view ${currentRoomImage + 1}`}
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" />

                            <button
                                type="button"
                                onClick={goToPrevRoomImage}
                                aria-label="Previous room image"
                                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/85 text-gray-900 hover:bg-white flex items-center justify-center transition-colors"
                            >
                                <ChevronLeft className="w-5 h-5" />
                            </button>
                            <button
                                type="button"
                                onClick={goToNextRoomImage}
                                aria-label="Next room image"
                                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/85 text-gray-900 hover:bg-white flex items-center justify-center transition-colors"
                            >
                                <ChevronRight className="w-5 h-5" />
                            </button>

                            <div className="absolute bottom-5 left-0 right-0 flex justify-center gap-2 px-4">
                                {ROOM_IMAGES.map((_, index) => (
                                    <button
                                        key={`room-dot-${index}`}
                                        type="button"
                                        onClick={() => setCurrentRoomImage(index)}
                                        aria-label={`Go to room image ${index + 1}`}
                                        className={`h-2.5 rounded-full transition-all ${index === currentRoomImage ? 'w-8 bg-emerald-500' : 'w-2.5 bg-white/70 hover:bg-white'}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

const Facilities = () => {
    return (
        <section id="facilities" className="py-6 md:py-10 lg:py-14 bg-white">
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-end mb-6 md:mb-12 lg:mb-14">
                    <div className="max-w-2xl">
                        <h2 className="text-sm font-bold text-emerald-600 tracking-widest uppercase mb-2">Resort Amenities</h2>
                        <h3 className="text-2xl md:text-4xl font-serif text-gray-900 font-bold mb-2 md:mb-4">Everything You Need in the Mountains</h3>
                        <p className="text-gray-600 text-base md:text-lg">We blend modern comforts with traditional Himachali hospitality to ensure your stay in Manali is memorable, relaxing, and worry-free.</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
                    {FACILITIES.map((fac, idx) => (
                        <div key={idx} className="p-5 md:p-8 border border-gray-100 rounded-2xl bg-gray-50">
                            <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-100 text-emerald-600 rounded-xl flex items-center justify-center mb-4 md:mb-6">
                                {fac.icon}
                            </div>
                            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{fac.name}</h4>
                            <p className="text-gray-600 leading-relaxed">{fac.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const ContactBooking = () => {
    return (
        <section id="contact" className="py-6 md:py-10 lg:py-14 bg-gray-50 relative">
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8">

                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                    <div className="grid grid-cols-1 lg:grid-cols-2">

                        {/* Direct Booking CTA */}
                        <div className="p-7 md:p-12 flex flex-col justify-center">
                            <h2 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-3">Book Your Stay Directly</h2>
                            <p className="text-gray-600 mb-6 text-base md:text-lg leading-relaxed">
                                Skip the forms and wait times! Contact us directly via WhatsApp or give us a call for instant reservations, personalized offers, and the best available rates.
                            </p>

                            <div className="space-y-3 mt-3">
                                <a
                                    href="https://wa.me/919278065558?text=Hello!%20I%20would%20like%20to%20inquire%20about%20booking%20a%20room%20at%20Apple%20Town%20Manali."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-full flex items-center justify-center py-3.5 bg-[#25D366] text-white rounded-lg font-bold text-base md:text-lg hover:bg-[#20bd5a] transition-colors shadow-lg hover:shadow-xl"
                                >
                                    <WhatsAppIcon className="w-6 h-6 mr-3" />
                                    Book via WhatsApp
                                </a>

                                <a
                                    href="tel:+919278065558"
                                    className="w-full flex items-center justify-center py-3.5 bg-emerald-600 text-white rounded-lg font-bold text-base md:text-lg hover:bg-emerald-700 transition-colors shadow-lg hover:shadow-xl"
                                >
                                    <Phone className="w-6 h-6 mr-3" />
                                    Call Us Now
                                </a>
                            </div>
                        </div>

                        {/* Map & Contact Info */}
                        <div className="bg-gray-900 text-white relative flex flex-col border-t-4 border-gray-200 lg:border-t-0 lg:border-l lg:border-gray-800 mt-2 lg:mt-0">
                            {/* Google Map Embedded */}
                            <div className="h-64 sm:h-72 lg:h-3/5 w-full bg-gray-800">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3378.5547953896985!2d77.1531133117899!3d32.13532367382958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39048b6c74c9f567%3A0x981983dfb3428420!2sHotel%20Luxe%20Signature!5e0!3m2!1sen!2sin!4v1774990475615!5m2!1sen!2sin" 
                                width="100%"
                                 height="100%" 
                                 style={{ border: 0 }} 
                                 allowfullscreen="" 
                                 loading="lazy" 
                                 referrerpolicy="no-referrer-when-downgrade"
                                 title="Hotel Location Map">
                                </iframe>
                            </div>

                            <div className="p-6 md:p-9 flex-grow flex flex-col justify-center">
                                <h3 className="text-lg md:text-2xl font-serif font-bold mb-4 md:mb-6 text-emerald-400">Contact Information</h3>

                                <div className="space-y-4 md:space-y-5">
                                    <div className="flex items-start">
                                        <MapPin className="w-6 h-6 mr-4 text-emerald-500 flex-shrink-0 mt-1" />
                                        <div>
                                            <h4 className="font-medium text-base md:text-lg">Location</h4>
                                            <p className="text-gray-400 mt-1 text-sm md:text-base">14 Mile, Near Span Resort,<br />Manali, Himachal Pradesh 175129</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <Phone className="w-6 h-6 mr-4 text-emerald-500 flex-shrink-0 mt-1" />
                                        <div>
                                            <h4 className="font-medium text-base md:text-lg">Phone</h4>
                                            <p className="text-gray-400 mt-1 text-sm md:text-base">+91 92780 65558</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};


const Footer = () => {
    return (
        <footer className="bg-gray-950 text-gray-400 py-12 border-t border-gray-800">
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                    <div className="flex items-center gap-3 mb-6">
                        <img
                            src={LOGO_IMG}
                            alt="Apple Town Manali Logo"
                            className="h-16 w-16 rounded-full object-cover border-2 border-gray-700 shadow-md"
                        />
                    </div>
                    <p className="mb-6">Experience the true essence of Manali with luxury, nature, and warm Himachali hospitality.</p>
                    <div className="flex space-x-4">
                        <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-emerald-600 text-white transition-colors cursor-pointer">
                            <FacebookIcon className="w-5 h-5" />
                        </a>
                        <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-emerald-600 text-white transition-colors cursor-pointer">
                            <InstagramIcon className="w-5 h-5" />
                        </a>
                        <a href="https://wa.me/919278065558?text=Hello!%20I%20would%20like%20to%20inquire%20about%20booking%20a%20room%20at%20Apple%20Town%20Manali." target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#25D366] text-white transition-colors cursor-pointer">
                            <WhatsAppIcon className="w-5 h-5" />
                        </a>
                    </div>
                </div>

                <div className="md:ml-auto">
                    <h3 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Quick Links</h3>
                    <ul className="space-y-2">
                        <li><a href="#home" className="hover:text-emerald-400 transition-colors">Home</a></li>
                        <li><a href="#rooms" className="hover:text-emerald-400 transition-colors">Accommodations</a></li>
                        <li><a href="#facilities" className="hover:text-emerald-400 transition-colors">Facilities</a></li>
                    </ul>
                </div>

                <div className="md:ml-auto">
                    <h3 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Policies</h3>
                    <ul className="space-y-2">
                        <li><a href="#" className="hover:text-emerald-400 transition-colors">Privacy Policy</a></li>
                        <li><a href="#" className="hover:text-emerald-400 transition-colors">Terms of Service</a></li>
                        <li><a href="#" className="hover:text-emerald-400 transition-colors">Cancellation Policy</a></li>
                    </ul>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 max-[375px]:px-5 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-gray-800 text-sm text-center">
                <p>&copy; {new Date().getFullYear()} {HOTEL_NAME}. All rights reserved.</p>
            </div>
        </footer>
    );
};


// --- Main Application Wrapper ---

export default function App() {
    const [isScrolled, setIsScrolled] = useState(false);

    // Handle Navbar Background on Scroll
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 font-sans selection:bg-emerald-500 selection:text-white" style={{ scrollBehavior: 'smooth' }}>
            <Navbar isScrolled={isScrolled} />
            <Hero />
            <Rooms />
            <Facilities />
            <ContactBooking />
            <Footer />
        </div>
    );
}